module.exports = __webpack_public_path__ + "img/schema_selle_3.ea1f9eed.svg";